export default defineNuxtPlugin(() => {
  if (process.client) {
    import('cropperjs').then(() => {
      console.log('Cropper.js v2 web components registered');
    });
  }
});
